module.exports = __webpack_public_path__ + "img/team-engineering-bg.68ae477f.svg";